// extracted by mini-css-extract-plugin
export default {"wrapper":"F521J","banner":"WrnVn","image":"YuPE1","content":"vYRCO","title":"iwaPr","showroom":"LqUt3","address":"xA6rR","phone":"MFwkq"};